import Overview from './Overview'
import Situation from './Situation'

export default {
  Overview,
  Situation
}